import { writable, type Writable } from "svelte/store";

const menuOpen: Writable<boolean> = writable(false);
const searchbarOpen: Writable<boolean> = writable(false);


export {
    menuOpen, 
    searchbarOpen
}